import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AnaliseVendaBi01Module } from '../bi01-analise-venda/analise-venda-bi01.module';
import { AnaliseMargemBi02Module } from '../bi02-analise-margem/analise-margem-bi02.module';
import { AnalisePassagemBi03Module } from '../bi03-analise-passagem/analise-passagem-bi03.module';
import { AnaliseEstoqueBi04Module } from '../bi04-analise-estoque/analise-estoque-bi04.module';
import { AnaliseHoraBi05Module } from '../bi05-analise-hora/analise-hora-bi05.module';
import { ComumModule } from '../../../../shared/comum.module';
import { translateLoaderNBS } from '../../../../shared/translate-loader/translateLoader';
import { RelatorioAnaliseGeralFiltroComponent } from './bi-relatorio-analise-filtro/bi-relatorio-analise-filtro.component';
import { RelatorioAnaliseGeralListaComponent } from './bi-relatorio-analise-lista/bi-relatorio-analise-lista.component';
import { RelatorioAnaliseGeralComponent } from './bi-relatorio-analise.component';
import { BiRelatorioAnaliseService } from './bi-relatorio-analise.service';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    AnaliseVendaBi01Module,
    AnaliseMargemBi02Module,
    AnalisePassagemBi03Module,
    AnaliseEstoqueBi04Module,
    AnaliseHoraBi05Module,
    CalendarModule,
    DialogModule,
    DropdownModule,
    ButtonModule,
    BrowserModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ToastModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    RelatorioAnaliseGeralComponent
  ],
  declarations: [
    RelatorioAnaliseGeralComponent,
    RelatorioAnaliseGeralListaComponent,
    RelatorioAnaliseGeralFiltroComponent
  ],
  providers: [
    BiRelatorioAnaliseService
  ]
})
export class RelatorioAnaliseGeralModule { }
